import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconQuickSearch: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="quick-search, quick-menu, command-k"><path d="M18 17L21.5 20.5" stroke="currentColor" strokeWidth="1.5"/><path d="M12 19.25C16.5563 19.25 20.25 15.5563 20.25 11C20.25 6.44365 16.5563 2.75 12 2.75C7.44365 2.75 3.75 6.44365 3.75 11" stroke="currentColor" strokeWidth="1.5"/><path d="M3 16.875L8.78571 10L8.14286 14.125H12L6.21429 21L6.85714 16.875H3Z" fill="currentColor"/></CentralIconBase>;
};

export default IconQuickSearch;
